import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import BiomeInfoModal from './BiomeInfoModal';
import BiomePanel from './BiomePanel';
import CompareModal from './CompareModal';
import CreditsModal from './CreditsModal';
import ErrorHandler from './ErrorHandler';
import Globe from './Globe';
import LayerLegend from './LayerLegend';
import LoadingScreen from './LoadingScreen';
import MenuBar from './MenuBar';
import SearchBar from './SearchBar';
import Timeline from './Timeline';

const Root = ({isLoading}) => (
  <ErrorHandler>
    <div className="Root">
      {/* we always want the globe mounted whether it's visible or not*/}
      <Globe />
      <LayerLegend />
      <div className="Root__uiContainer">
        <MenuBar />
        <SearchBar />
      </div>
      <Timeline />
      <BiomePanel />
      <CompareModal />
      <BiomeInfoModal />
      <CreditsModal />
      {isLoading && <LoadingScreen />}
    </div>
  </ErrorHandler>
);

Root.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: state.init.isLoading,
});

export { Root };
export default connect(mapStateToProps)(Root);



// WEBPACK FOOTER //
// ./src/components/Root.js